import { ConsolidationLoosePickDto, ConsolidationToteDto } from "~/types/api";

export const areAllTotesInStatus = (
  totesOrPicks: (ConsolidationLoosePickDto | ConsolidationToteDto)[],
  statuses: string[]
): boolean =>
  totesOrPicks.every((toteOrPick) => statuses.includes(toteOrPick.status));
